import React from "react";
import { Div, Text, Row, Col, Image, StyleReset } from "atomize";
import { Input, Button, Tag, Anchor, Icon } from "atomize/dist";
import CustomContainer from "../common/CustomContainer";
import WebsiteContainer from "../common/WebsiteContainer";
import AnimateLink from "../common/AnimateLink";
import ImageLink from "../common/ImageLink";
import {
  getUTMcookie,
  addUtmToUrl,
  addUtmInputValues,
} from "../../utilities/helpers";

const PricingDemo = ({ title, link, link2, button1, button2 }) => (
  <>
    <WebsiteContainer>
      <CustomContainer p={{ xs: "0", md: "2.5rem" }}>
        <Div
          bg="yellowGray"
          d="flex"
          p={{ xs: "5.56rem 0", md: "5rem 0", lg: "9rem 0" }}
          align="center"
          flexDir="column"
          m={{ xs: "5rem 0", md: "10rem 0" }}
        >
          <ImageLink link="">
            <Image src="/images/all-white-logo.png" maxW="4.3rem" />
          </ImageLink>
          <Text
            textSize={{ xs: "title2", md: "subheader3" }}
            textWeight="600"
            textAlign="center"
            m="1.125rem 0"
            maxW={{ xs: "19.25rem", md: "26rem" }}
            style={{ lineHeight: "34px" }}
          >
            {title}
          </Text>
          <Div d="flex">
            <AnimateLink to={link} activeClassName="active">
              <Button
                textTransform="uppercase"
                bg="rgba(255,255,255,0.15)"
                border="1px solid"
                borderColor="rgba(255,255,255,0.5)"
                textWeight="600"
                textSize="caption"
                rounded="xs"
                p="0 0.75rem"
                h="2rem"
                m={{ r: "11px" }}
                style={{ letterSpacing: "1.8px" }}
              >
                {button1}
              </Button>
            </AnimateLink>
            <Button
              textTransform="uppercase"
              bg="rgba(255,255,255,0.15)"
              border="1px solid"
              borderColor="rgba(255,255,255,0.5)"
              textWeight="600"
              textSize="caption"
              rounded="xs"
              p="0 1.9rem"
              h="2rem"
              style={{ letterSpacing: "1.8px" }}
              onClick={() => {
                const tags = getUTMcookie();
                const url = addUtmToUrl("https://app.trend.io/signup", tags);
                window.location.href = url;

                // console.log({ url });
              }}
            >
              {button2}
            </Button>
          </Div>
        </Div>
      </CustomContainer>
    </WebsiteContainer>
  </>
);

export default PricingDemo;
